import * as angular from 'angular';

import ViewService from '../../../services/view-service';

class TableColumnSettingsController {
  token: string;
  columnView: any;
  view: any;

  selectedColumn: string;

  static $inject = ['$scope', 'ViewService'];

  constructor(
    private $scope: angular.IScope,
    private vs: ViewService
  ) {}

  $onInit = () => {
    this.onSelectedColumnChanged();
  };

  $onChanges = (changed) => {
    if (changed.view || changed.selectedColumn) {
      this.onSelectedColumnChanged();
    }
  };

  updateSettings(formatOptions) {
    this.columnView = formatOptions;
    this.view.columns[this.selectedColumn] = this.columnView;
    this.vs.updateTableColumnSettings(this.token, this.selectedColumn, this.columnView);
  }

  private onSelectedColumnChanged() {
    // Hacky defaulting
    this.view.columns = this.view.columns || {};
    this.columnView = this.view.columns[this.selectedColumn] || {};
  }
}

export const TableColumnSettings: angular.IComponentOptions = {
  controller: TableColumnSettingsController,
  controllerAs: 'ctrl',
  template: `
    <h3 class="setting-title no-border-top">{{ctrl.selectedColumn}}</h3>
    <format-settings format-options="ctrl.columnView" on-change="ctrl.updateSettings($formatOptions)"></format-settings>
  `,
  bindings: {
    view: '<',
    token: '<',
    selectedColumn: '<',
  },
};
